<template lang="pug">
  v-dialog(v-model='dialogRoleo', persistent='', max-width='100%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        v-toolbar-title.headline Información de roleo
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense)
                  table.tabla(border='0' width='100%' align='center')
                    tr
                      td(align="center")
                        div(style='padding-top: 5px;')
                          v-icon(color='success') mdi-check-circle
                          span.bold(style='color: black') Original
                      td.text( align="center" width='14%')
                        div
                          span.bold(style='color: black') ETD 1
                          v-text-field(v-if='fechasOriginales.fechaETD1' dense outlined readonly style='margin-bottom: -13px;' v-model='fechasOriginales.fechaETD1' prepend-inner-icon='event')
                      td.text( align="center" width='14%')
                        div
                          span.bold(style='color: black') ETA 1
                          v-text-field(v-if='fechasOriginales.fechaETA1' dense outlined readonly style='margin-bottom: -13px;' v-model='fechasOriginales.fechaETA1' prepend-inner-icon='event')
                      td.text( align="center" width='14%')
                        div
                          span.bold(style='color: black') ETD 2
                          v-text-field(v-if='fechasOriginales.fechaETD2' dense outlined readonly style='margin-bottom: -13px;' v-model='fechasOriginales.fechaETD2' prepend-inner-icon='event')
                      td.text( align="center" width='14%')
                        div
                          span.bold(style='color: black') ETA 2
                          v-text-field(v-if='fechasOriginales.fechaETA2' dense outlined readonly style='margin-bottom: -13px;' v-model='fechasOriginales.fechaETA2' prepend-inner-icon='event')
                      td.text( align="center" width='14%')
                        div
                          span.bold(style='color: black') ATA
                          v-text-field(v-if='fechasOriginales.fechaATA' dense outlined readonly style='margin-bottom: -13px;' v-model='fechasOriginales.fechaATA' prepend-inner-icon='event')
                      td.text( align="center" width='14%')
                        div
                          span.bold(style='color: black') ETA 3
                          v-text-field(v-if='fechasOriginales.fechaETA3' dense outlined readonly style='margin-bottom: -13px;' v-model='fechasOriginales.fechaETA3' prepend-inner-icon='event')
                p.top-black
                v-flex(xs12 style='margin-top:5px;padding-left:20px;margin-bottom:5px')
                  v-layout(wrap='')
                    v-flex(xs12 sm12 md6)
                      v-row(dense class='d-flex justify-center')
                        h3(style='font-weight: bold; color: black' align="center") Roleos de ETD 1
                        v-icon(v-if="read === false" dark='' color='success' @click='nuevoRoleoETD1()') mdi-plus-circle
                      v-row(dense v-if='showRoleo1ETD1')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-left: 50px;')
                            span.bold(style='color: black') Roleo 1 
                            v-icon(color='success' large) mdi-ray-start-arrow
                        v-col(cols='6' sm='6' md='4' v-if="!read" align="center")
                          v-dialog(ref='dialogRoleo1ETD1' v-model='modalRoleo1ETD1' :return-value.sync='date' readonly persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined readonly v-model='fechaRoleo1ETD1' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='fechaRoleo1ETD1' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalRoleo1ETD1 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogRoleo1ETD1.save(date)') Ok
                        v-col(cols='6' sm='6' md='4' v-else align="center")
                          v-text-field(dense outlined v-model='fechaRoleo1ETD1' prepend-inner-icon='event')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-top: 10px;padding-right: 150px;')
                            v-icon(v-if="read === false" dark='' color='error' @click='deleleRoleo1ETD1()') mdi-delete
                      v-row(dense v-if='showRoleo2ETD1')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-left: 50px;')
                            span.bold(style='color: black') Roleo 2 
                            v-icon(color='success' large) mdi-ray-start-arrow
                        v-col(cols='6' sm='6' md='4' v-if="!read" align="center")
                          v-dialog(ref='dialogRoleo2ETD1' v-model='modalRoleo2ETD1' :return-value.sync='date' readonly persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined readonly v-model='fechaRoleo2ETD1' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='fechaRoleo2ETD1' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalRoleo2ETD1 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogRoleo2ETD1.save(date)') Ok
                        v-col(cols='6' sm='6' md='4' v-else align="center")
                          v-text-field(dense outlined v-model='fechaRoleo2ETD1' prepend-inner-icon='event')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-top: 10px;padding-right: 150px;')
                            v-icon(v-if="read === false" dark='' color='error' @click='deleleRoleo2ETD1()') mdi-delete
                      v-row(dense v-if='showRoleo3ETD1')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-left: 50px;')
                            span.bold(style='color: black') Roleo 3 
                            v-icon(color='success' large) mdi-ray-start-arrow
                        v-col(cols='6' sm='6' md='4' v-if="!read" align="center")
                          v-dialog(ref='dialogRoleo3ETD1' v-model='modalRoleo3ETD1' :return-value.sync='date' readonly persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined readonly v-model='fechaRoleo3ETD1' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='fechaRoleo3ETD1' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalRoleo3ETD1 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogRoleo3ETD1.save(date)') Ok
                        v-col(cols='6' sm='6' md='4' v-else align="center")
                          v-text-field(dense outlined v-model='fechaRoleo3ETD1' prepend-inner-icon='event')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-top: 10px;padding-right: 150px;')
                            v-icon(v-if="read === false" dark='' color='error' @click='deleleRoleo3ETD1()') mdi-delete
                      v-row(dense v-if='showRoleo4ETD1')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-left: 50px;')
                            span.bold(style='color: black') Roleo 4 
                            v-icon(color='success' large) mdi-ray-start-arrow
                        v-col(cols='6' sm='6' md='4' v-if="!read" align="center")
                          v-dialog(ref='dialogRoleo4ETD1' v-model='modalRoleo4ETD1' :return-value.sync='date' readonly persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined readonly v-model='fechaRoleo4ETD1' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='fechaRoleo4ETD1' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalRoleo4ETD1 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogRoleo4ETD1.save(date)') Ok
                        v-col(cols='6' sm='6' md='4' v-else align="center")
                          v-text-field(dense outlined v-model='fechaRoleo4ETD1' prepend-inner-icon='event')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-top: 10px;padding-right: 150px;')
                            v-icon(v-if="read === false" dark='' color='error' @click='deleleRoleo4ETD1()') mdi-delete
                    v-flex(xs12 sm12 md6)
                      v-row(dense class='d-flex justify-center')
                        h3(style='font-weight: bold; color: black' align="center") Roleos de ETD 2
                        v-icon(v-if="read === false" dark='' color='success' @click='nuevoRoleoETD2()') mdi-plus-circle
                      v-row(dense v-if='showRoleo1ETD2')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-left: 50px;')
                            span.bold(style='color: black') Roleo 1 
                            v-icon(color='success' large) mdi-ray-start-arrow
                        v-col(cols='6' sm='6' md='4' v-if="!read" align="center")
                          v-dialog(ref='dialogRoleo1ETD2' v-model='modalRoleo1ETD2' :return-value.sync='date' readonly persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined readonly v-model='fechaRoleo1ETD2' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='fechaRoleo1ETD2' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalRoleo1ETD2 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogRoleo1ETD2.save(date)') Ok
                        v-col(cols='6' sm='6' md='4' v-else align="center")
                          v-text-field(dense outlined v-model='fechaRoleo1ETD2' prepend-inner-icon='event')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-top: 10px;padding-right: 150px;')
                            v-icon(v-if="read === false" dark='' color='error' @click='deleleRoleo1ETD2()') mdi-delete
                      v-row(dense v-if='showRoleo2ETD2')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-left: 50px;')
                            span.bold(style='color: black') Roleo 2 
                            v-icon(color='success' large) mdi-ray-start-arrow
                        v-col(cols='6' sm='6' md='4' v-if="!read" align="center")
                          v-dialog(ref='dialogRoleo2ETD2' v-model='modalRoleo2ETD2' :return-value.sync='date' readonly persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined readonly v-model='fechaRoleo2ETD2' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='fechaRoleo2ETD2' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalRoleo2ETD2 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogRoleo2ETD2.save(date)') Ok
                        v-col(cols='6' sm='6' md='4' v-else align="center")
                          v-text-field(dense outlined v-model='fechaRoleo2ETD2' prepend-inner-icon='event')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-top: 10px;padding-right: 150px;')
                            v-icon(v-if="read === false" dark='' color='error' @click='deleleRoleo2ETD2()') mdi-delete
                      v-row(dense v-if='showRoleo3ETD2')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-left: 50px;')
                            span.bold(style='color: black') Roleo 3 
                            v-icon(color='success' large) mdi-ray-start-arrow
                        v-col(cols='6' sm='6' md='4' v-if="!read" align="center")
                          v-dialog(ref='dialogRoleo3ETD2' v-model='modalRoleo3ETD2' :return-value.sync='date' readonly persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined readonly v-model='fechaRoleo3ETD2' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='fechaRoleo3ETD2' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalRoleo3ETD2 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogRoleo3ETD2.save(date)') Ok
                        v-col(cols='6' sm='6' md='4' v-else align="center")
                          v-text-field(dense outlined v-model='fechaRoleo3ETD2' prepend-inner-icon='event')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-top: 10px;padding-right: 150px;')
                            v-icon(v-if="read === false" dark='' color='error' @click='deleleRoleo3ETD2()') mdi-delete
                      v-row(dense v-if='showRoleo4ETD2')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-left: 50px;')
                            span.bold(style='color: black') Roleo 4 
                            v-icon(color='success' large) mdi-ray-start-arrow
                        v-col(cols='6' sm='6' md='4' v-if="!read" align="center")
                          v-dialog(ref='dialogRoleo4ETD2' v-model='modalRoleo4ETD2' :return-value.sync='date' readonly persistent width='300px')
                            template(v-slot:activator='{ on }')
                              v-text-field(dense outlined readonly v-model='fechaRoleo4ETD2' prepend-inner-icon='event' v-on='on')
                            v-date-picker( v-model='fechaRoleo4ETD2' locale="ES")
                              v-spacer
                              v-btn(small dark color='red' @click='modalRoleo4ETD2 = false') Cancelar
                              v-btn(small dark color='success' @click='$refs.dialogRoleo4ETD2.save(date)') Ok
                        v-col(cols='6' sm='6' md='4' v-else align="center")
                          v-text-field(dense outlined v-model='fechaRoleo4ETD2' prepend-inner-icon='event')
                        v-col(align="center" cols='12' sm='12' md='4')
                          div(style='padding-top: 10px;padding-right: 150px;')
                            v-icon(v-if="read === false" dark='' color='error' @click='deleleRoleo4ETD2()') mdi-delete
      v-card-actions
        v-btn(color='error' small dark @click='closeRoleo')
          v-icon mdi-close
          | Cancelar
        v-spacer
        v-btn(color='success' v-if="read === false" style="margin-right: 1%" dark small @click='saveRoleo')
          v-icon mdi-content-save
          | Guardar
</template>

<script>
import { EventBus } from '../../Events'
export default {
  props: ['dialogRoleo'],
  data: () => ({
    read: false,
    date: new Date().toISOString().substr(0, 10),
    fechasOriginales: {},
    dialogRoleo1ETD1: false, // pickers ETD 1
    modalRoleo1ETD1: false,
    dialogRoleo2ETD1: false,
    modalRoleo2ETD1: false,
    dialogRoleo3ETD1: false,
    modalRoleo3ETD1: false,
    dialogRoleo4ETD1: false,
    modalRoleo4ETD1: false,
    showRoleo1ETD1: false, // para mostra los campos del roleo ETD 1
    showRoleo2ETD1: false,
    showRoleo3ETD1: false,
    showRoleo4ETD1: false,
    fechaRoleo1ETD1: '', // fechas de los roleos ETD 1
    fechaRoleo2ETD1: '',
    fechaRoleo3ETD1: '',
    fechaRoleo4ETD1: '',

    dialogRoleo1ETD2: false, // pickers ETD 1
    modalRoleo1ETD2: false,
    dialogRoleo2ETD2: false,
    modalRoleo2ETD2: false,
    dialogRoleo3ETD2: false,
    modalRoleo3ETD2: false,
    dialogRoleo4ETD2: false,
    modalRoleo4ETD2: false,
    showRoleo1ETD2: false, // para mostra los campos del roleo ETD 1
    showRoleo2ETD2: false,
    showRoleo3ETD2: false,
    showRoleo4ETD2: false,
    fechaRoleo1ETD2: '', // fechas de los roleos ETD 1
    fechaRoleo2ETD2: '',
    fechaRoleo3ETD2: '',
    fechaRoleo4ETD2: ''
  }),

  watch: {},

  created () {
    EventBus.$on('dataRoleo', data => {
      console.log('DATA', data)
      this.fechasOriginales = data.fechas
      this.read = data.read
    })
  },

  methods: {
    nuevoRoleoETD1 () { // para ETD 1
      this.showRoleo1ETD1 = true
      if (this.fechaRoleo1ETD1 !== '') {
        this.showRoleo2ETD1 = true
      }
      if (this.fechaRoleo1ETD1 !== '' && this.fechaRoleo2ETD1 !== '') {
        this.showRoleo3ETD1 = true
      }
      if (this.fechaRoleo1ETD1 !== '' && this.fechaRoleo2ETD1 !== '' && this.fechaRoleo3ETD1 !== '') {
        this.showRoleo4ETD1 = true
      }
    },
    deleleRoleo1ETD1 () {
      if (this.showRoleo2ETD1 === false && this.showRoleo3ETD1 === false && this.showRoleo4ETD1 === false) {
        this.fechaRoleo1ETD1 = ''
        this.showRoleo1ETD1 = false
      }
    },
    deleleRoleo2ETD1 () {
      if (this.showRoleo3ETD1 === false && this.showRoleo4ETD1 === false) {
        this.fechaRoleo2ETD1 = ''
        this.showRoleo2ETD1 = false
      }
    },
    deleleRoleo3ETD1 () {
      if (this.showRoleo4ETD1 === false) {
        this.fechaRoleo3ETD1 = ''
        this.showRoleo3ETD1 = false
      }
    },
    deleleRoleo4ETD1 () {
      this.fechaRoleo4ETD1 = ''
      this.showRoleo4ETD1 = false
    },

    nuevoRoleoETD2 () { // para ETD 2
      this.showRoleo1ETD2 = true
      if (this.fechaRoleo1ETD2 !== '') {
        this.showRoleo2ETD2 = true
      }
      if (this.fechaRoleo1ETD2 !== '' && this.fechaRoleo2ETD2 !== '') {
        this.showRoleo3ETD2 = true
      }
      if (this.fechaRoleo1ETD2 !== '' && this.fechaRoleo2ETD2 !== '' && this.fechaRoleo3ETD2 !== '') {
        this.showRoleo4ETD2 = true
      }
    },
    deleleRoleo1ETD2 () {
      if (this.showRoleo2ETD2 === false && this.showRoleo3ETD2 === false && this.showRoleo4ETD2 === false) {
        this.fechaRoleo1ETD2 = ''
        this.showRoleo1ETD2 = false
      }
    },
    deleleRoleo2ETD2 () {
      if (this.showRoleo3ETD2 === false && this.showRoleo4ETD2 === false) {
        this.fechaRoleo2ETD2 = ''
        this.showRoleo2ETD2 = false
      }
    },
    deleleRoleo3ETD2 () {
      if (this.showRoleo4ETD2 === false) {
        this.fechaRoleo3ETD2 = ''
        this.showRoleo3ETD2 = false
      }
    },
    deleleRoleo4ETD2 () {
      this.fechaRoleo4ETD2 = ''
      this.showRoleo4ETD2 = false
    },

    closeRoleo () {
      this.fechaRoleo1ETD1 = ''
      this.fechaRoleo2ETD1 = ''
      this.fechaRoleo3ETD1 = ''
      this.fechaRoleo4ETD1 = ''
      this.fechaRoleo1ETD2 = ''
      this.fechaRoleo2ETD2 = ''
      this.fechaRoleo3ETD2 = ''
      this.fechaRoleo4ETD2 = ''
      this.showRoleo1ETD1 = false
      this.showRoleo2ETD1 = false
      this.showRoleo3ETD1 = false
      this.showRoleo4ETD1 = false
      this.showRoleo1ETD2 = false
      this.showRoleo2ETD2 = false
      this.showRoleo3ETD2 = false
      this.showRoleo4ETD2 = false
      this.$emit('closeRoleo')
    },

    saveRoleo () {

      this.$emit('saveRoleo')
    }
  }
}
</script>

<style lang="scss">
  .text {
    padding: 0px 10px 0px 0px;
  }
</style>
